var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "matrix(-1 0 0 1 56.5 0)",
    fill: "url(#paint0_linear_421_287)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1055 19.0977C26.3568 19.0977 23.3086 22.1467 23.3086 25.8946C23.3086 29.6424 26.3568 32.6914 30.1055 32.6914C33.8542 32.6914 36.9024 29.6424 36.9024 25.8946C36.9024 22.1467 33.8542 19.0977 30.1055 19.0977ZM34.1046 24.796L29.8566 29.0441C29.6906 29.21 29.4731 29.293 29.2559 29.293C29.0386 29.293 28.8211 29.21 28.6552 29.0441L26.1063 26.4953C25.7745 26.1634 25.7745 25.6257 26.1063 25.2939C26.4382 24.962 26.9759 24.962 27.3077 25.2939L29.2559 27.242L32.9032 23.5946C33.2351 23.2627 33.7728 23.2627 34.1046 23.5946C34.4365 23.9265 34.4365 24.4642 34.1046 24.796Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2489 39.1466C12.917 39.4785 12.917 40.0162 13.2489 40.348L15.6517 42.7509C15.8177 42.9168 16.0352 42.9998 16.2524 42.9998C16.4697 42.9998 16.6872 42.9168 16.8531 42.7509L21.1116 38.4924L17.5074 34.8882L13.2489 39.1466Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1055 14C23.5476 14 18.2109 19.3357 18.2109 25.8946C18.2109 28.2529 18.9092 30.4471 20.0978 32.2981L18.7088 33.6871L22.313 37.2913L23.702 35.9023C25.553 37.0909 27.7474 37.7891 30.1055 37.7891C36.6635 37.7891 42.0001 32.4534 42.0001 25.8946C42.0001 19.3357 36.6635 14 30.1055 14ZM30.1055 34.3907C25.4209 34.3907 21.6094 30.5789 21.6094 25.8946C21.6094 21.2102 25.4209 17.3984 30.1055 17.3984C34.7899 17.3984 38.6016 21.2102 38.6016 25.8946C38.6016 30.5789 34.7899 34.3907 30.1055 34.3907Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_287",
    x1: 23.0588,
    y1: 58.1961,
    x2: 43.9216,
    y2: 3.00613e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00",
    stopOpacity: 0.16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.4c849fa2efdb40cbcad176b96803a16e.svg";
export { ForwardRef as ReactComponent };